var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "url(#paint0_linear_1_433)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08334 20.1667C7.50119 17.4194 7.50119 14.5806 8.08334 11.8333C8.15983 11.5543 8.30762 11.3001 8.51218 11.0955C8.71674 10.8909 8.97101 10.7432 9.25001 10.6667C13.7195 9.92622 18.2805 9.92622 22.75 10.6667C23.029 10.7432 23.2833 10.8909 23.4878 11.0955C23.6924 11.3001 23.8402 11.5543 23.9167 11.8333C24.4988 14.5806 24.4988 17.4194 23.9167 20.1667C23.8402 20.4457 23.6924 20.6999 23.4878 20.9045C23.2833 21.1091 23.029 21.2568 22.75 21.3333C18.2805 22.0739 13.7195 22.0739 9.25001 21.3333C8.97101 21.2568 8.71674 21.1091 8.51218 20.9045C8.30762 20.6999 8.15983 20.4457 8.08334 20.1667Z",
    fill: "url(#paint1_linear_1_433)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.333 18.5L18.4997 16L14.333 13.5V18.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_433",
    x1: 0,
    y1: 16,
    x2: 32,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_433",
    x1: 7.64673,
    y1: 16.0001,
    x2: 24.3533,
    y2: 16.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.78433e63b781c6edb3e27a82c761303c.svg";
export { ForwardRef as ReactComponent };